import React, { useEffect, useState } from "react";
import { API } from "../../config/api";

export default function AddSubcategory() {
  const [name, setName] = useState("");
  const [subcategories, setSubcategories] = useState([]);
  const [editId, setEditId] = useState(null);
  const [listOrder, setListOrder] = useState("");
  useEffect(() => {
    fetchSubcategories();
  }, []);

  const fetchSubcategories = async () => {
    const res = await fetch(API.LIST_SUBCATEGORY);
    const data = await res.json();

    if (data.status) {
      setSubcategories(data.data);
    }
  };

  const saveSubcategory = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      alert("Enter Subcategory Name");
      return;
    }

    const fd = new FormData();
    fd.append("name", name);
    fd.append("list_no", listOrder);
    if (editId) {
      fd.append("id", editId);
    }

    const res = await fetch(
      editId ? API.UPDATE_SUBCATEGORY : API.ADD_SUBCATEGORY,
      {
        method: "POST",
        body: fd,
      },
    );

    const data = await res.json();

    alert(data.message);

    if (data.status) {
      setName("");
      setEditId(null);
      fetchSubcategories();
    }
  };

  const deleteSubcategory = async (id) => {
    if (!window.confirm("Delete this subcategory?")) return;

    const fd = new FormData();
    fd.append("id", id);

    const res = await fetch(API.DELETE_SUBCATEGORY, {
      method: "POST",
      body: fd,
    });

    const data = await res.json();

    alert(data.message);

    if (data.status) {
      fetchSubcategories();
    }
  };

  const editSubcategory = (item) => {
    setEditId(item.id);
    setName(item.name);
    setListOrder(item.list_no);
  };
  return (
    <div className="dashboard-content">
      <h2>Add Subcategory</h2>

      <form onSubmit={saveSubcategory} className="subcategory-form">
        <div className="row align-items-end g-3">
          <div className="col-md-10">
            <label className="form-label fw-semibold">Subcategory Name</label>
            <input
              type="text"
              placeholder="Enter Subcategory Name"
              className="form-control"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="col-md-1">
            <label className="form-label fw-semibold">List No</label>
            <input
              type="number"
              className="form-control"
              placeholder="1"
              value={listOrder}
              onChange={(e) => setListOrder(e.target.value)}
            />
          </div>

          <div className="col-md-1">
            <button type="submit" className="btn btn-primary w-100">
              {editId ? "Update" : "Save"}
            </button>
          </div>
        </div>
      </form>

      <div className="table-responsive bg-white p-3 rounded shadow-sm max-width-800">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th width="80">#</th>
              <th>Date</th>
              <th>Subcategory Name</th>
              <th>List No</th>

              <th width="180">Action</th>
            </tr>
          </thead>

          <tbody>
            {subcategories.length > 0 ? (
              subcategories.map((item, index) => (
                <tr key={item.id}>
                  <td>{subcategories.length - index}</td>
                  <td>{new Date(item.created_at).toLocaleDateString()}</td>
                  <td>{item.name}</td>
                  <td>{item.list_no}</td>
                  <td style={{ display: "FLEX" }}>
                    <button
                      className="btn st-edit-btn"
                      onClick={() => editSubcategory(item)}
                    >
                      <i className="bi bi-pencil"></i>
                    </button>

                    <button
                      className="btn st-delete-btn ms-2"
                      onClick={() => deleteSubcategory(item.id)}
                    >
                      <i className="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" align="center">
                  No Subcategories Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
